{
  "deviceGate.title": "Exognitos works best in the mobile app",
  "deviceGate.lede": "On a phone, Exognitos runs as a native app. Install it to capture, plan and review; your account and everything in it stays the same.",
  "deviceGate.downloads": "Download the app",
  "deviceGate.android": "Android",
  "deviceGate.ios": "iPhone",
  "deviceGate.googlePlay": "Get it on Google Play",
  "deviceGate.appStore": "Download on the App Store",
  "deviceGate.comingSoon": "Coming soon",
  "deviceGate.comingSoonHint": "The store listing is not published yet.",
  "deviceGate.accountHeading": "Already have an account?",
  "deviceGate.signIn": "Sign in",
  "deviceGate.register": "Create an account",
  "deviceGate.settings": "Account settings",
  "deviceGate.accountHint": "Signing in, signing up and account settings all work here — that is how the mobile apps authorise your account.",
  "deviceGate.language": "Language",
  "deviceGate.continueInBrowser": "Continue in the browser anyway",
  "deviceGate.continueInBrowserHint": "The full interface is built for a larger screen. This choice is remembered on this device.",
  "deviceGate.documentTitle": "Mobile app"
}
